module.exports = __webpack_public_path__ + "0c6239cf.woff";